var _jsxFileName = "/src/main/react/src/main/app/components/login/LoggedInUser.js";
import React, { Component } from 'react';
import { Grid, Typography, Box, Divider } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { withRouter } from 'react-router-dom';
import { LOCAL_STORAGE_ITEM_NAMES } from '../domain/constants';
import { stringToObj } from "../../util/StringUtil";
const styles = () => ({});
class LoggedInUser extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.dialogRef = null;
    this.setDialogRef = element => {
      this.dialogRef = element;
    };
  }
  render() {
    const impersonating = localStorage.getItem(LOCAL_STORAGE_ITEM_NAMES.impersonatingUser);
    const iUser = localStorage.getItem(LOCAL_STORAGE_ITEM_NAMES.impersonatedUsername);
    const iRole = localStorage.getItem(LOCAL_STORAGE_ITEM_NAMES.impersonatedRole);
    const iPartnersObjInLocalStorage = localStorage.getItem(LOCAL_STORAGE_ITEM_NAMES.impersonatedVisiblePartners);
    const iPartners = iPartnersObjInLocalStorage != null ? prettify(Object.values(stringToObj(iPartnersObjInLocalStorage))) : null;
    const partnersObjInLocalStorage = stringToObj(localStorage.getItem(LOCAL_STORAGE_ITEM_NAMES.partners));
    const username = impersonating ? iUser : localStorage.getItem(LOCAL_STORAGE_ITEM_NAMES.username);
    const role = impersonating ? iRole : localStorage.getItem(LOCAL_STORAGE_ITEM_NAMES.role);
    const partner = impersonating ? iPartners : partnersObjInLocalStorage != null ? prettify(Object.values(partnersObjInLocalStorage)) : null;
    return /*#__PURE__*/React.createElement(Grid, {
      container: true,
      item: true,
      alignContent: "center",
      alignItems: "flex-end",
      justify: "space-evenly",
      wrap: 'nowrap',
      direction: 'column',
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 34,
        columnNumber: 13
      }
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      container: true,
      alignContent: "center",
      alignItems: "center",
      justify: "space-evenly",
      wrap: 'nowrap',
      direction: 'row',
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 36,
        columnNumber: 17
      }
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      md: true,
      wrap: 'nowrap',
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 38,
        columnNumber: 21
      }
    }, /*#__PURE__*/React.createElement(Box, {
      fontWeight: 1000,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 39,
        columnNumber: 25
      }
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "subtitle2",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 40,
        columnNumber: 29
      }
    }, "Username:"))), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      md: true,
      wrap: 'nowrap',
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 43,
        columnNumber: 21
      }
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "subtitle2",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 44,
        columnNumber: 25
      }
    }, username))), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 47,
        columnNumber: 17
      }
    }, /*#__PURE__*/React.createElement(Divider, {
      orientation: 'horizontal',
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 48,
        columnNumber: 21
      }
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      container: true,
      alignContent: "center",
      alignItems: "center",
      justify: "space-evenly",
      wrap: 'nowrap',
      direction: 'row',
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 50,
        columnNumber: 17
      }
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      md: true,
      wrap: 'nowrap',
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 52,
        columnNumber: 21
      }
    }, /*#__PURE__*/React.createElement(Box, {
      fontWeight: 1000,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 53,
        columnNumber: 25
      }
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "subtitle2",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 54,
        columnNumber: 29
      }
    }, "Role:"))), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      md: true,
      wrap: 'nowrap',
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 57,
        columnNumber: 21
      }
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "subtitle2",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 58,
        columnNumber: 25
      }
    }, role))), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 61,
        columnNumber: 17
      }
    }, /*#__PURE__*/React.createElement(Divider, {
      orientation: 'horizontal',
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 62,
        columnNumber: 21
      }
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      container: true,
      alignContent: "center",
      alignItems: "center",
      justify: "space-evenly",
      wrap: 'nowrap',
      direction: 'row',
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 64,
        columnNumber: 17
      }
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      md: true,
      wrap: 'nowrap',
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 66,
        columnNumber: 21
      }
    }, /*#__PURE__*/React.createElement(Box, {
      fontWeight: 1000,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 67,
        columnNumber: 25
      }
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "subtitle2",
      component: 'strong',
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 68,
        columnNumber: 29
      }
    }, "Visible Partners:"))), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      md: true,
      wrap: 'nowrap',
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 71,
        columnNumber: 21
      }
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "subtitle2",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 72,
        columnNumber: 25
      }
    }, partner))));
  }
}

/**
 * Basically a toString() for a list of partners
 */
function prettify(partners) {
  let str = "";
  let firstSet = false;
  for (let partner of partners) {
    if (firstSet === true) {
      str += ', \n';
    }
    str += partner;
    firstSet = true;
  }
  return str;
}
export default withStyles(styles)(withRouter(LoggedInUser));